import { render, staticRenderFns } from "./BsSidebarFooter.vue?vue&type=template&id=7ab419a4&"
import script from "./BsSidebarFooter.vue?vue&type=script&lang=js&"
export * from "./BsSidebarFooter.vue?vue&type=script&lang=js&"
import style0 from "./BsSidebarFooter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports